import React from 'react'

export default function FlutterIcons() {
   return (
      <svg
         width="60"
         height="74"
         viewBox="0 0 60 74"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <g clipPath="url(#clip0_2355_46619)">
            <path
               d="M11.3952 48.3922L0 36.997L37 0H59.7874M59.7874 34.1407H37L28.4641 42.6767L39.8593 54.0719"
               fill="#1F473E"
            />
            <path
               d="M28.4639 65.464L36.9998 73.9999H59.7872L39.8591 54.0718"
               fill="#1F473E"
            />
            <path
               d="M17.0957 54.0778L28.473 42.6975L39.8502 54.0748L28.473 65.455L17.0957 54.0778Z"
               fill="#1F473E"
            />
            <path
               d="M28.4727 65.4551L39.8499 54.0779L41.4381 55.666L30.0608 67.0433L28.4727 65.4551Z"
               fill="#1F473E"
            />
            <path
               d="M28.4639 65.464L45.3712 59.6229L39.8591 54.0688"
               fill="#1F473E"
            />
         </g>
         <defs>
            <clippath id="clip0_2355_46619">
               <rect width="59.7874" height="74" fill="white" />
            </clippath>
         </defs>
      </svg>
   )
}
